'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _dekuRedux = require('@viskan/deku-redux');

var _actions = require('./actions');

var _components = require('./components');

var _components2 = _interopRequireDefault(_components);

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCategoryId = function getCategoryId(categoryId, latestCategoryId, article) {
	if (!article.art_id) {
		return categoryId;
	}

	if (latestCategoryId > 0) {
		var _articleCategory = article.articleCategories.find(function (category) {
			return category.category.cat_id === latestCategoryId;
		});

		if (_articleCategory) {
			return _articleCategory.category.cat_id;
		}
	}

	var articleCategory = article.articleCategories.find(function (category) {
		return category.default_flg;
	}) || article.articleCategories[0];

	return articleCategory ? articleCategory.category.cat_id : -1;
};

var component = (0, _dekuRedux.connect)(function (state) {
	var categoryId = getCategoryId(state.app.category.main.categoryId, state.app.latestCategoryId, state.article.article);

	return {
		article: state.article.article,
		articleUrlPrefix: state.site.articleUrlPrefix,
		categoryId: categoryId,
		data: state.cmsComponents.breadcrumbs.data[categoryId]
	};
}, function (dispatch) {
	return {
		fetch: function fetch(categoryId) {
			return dispatch((0, _actions.fetch)(categoryId));
		}
	};
})(_components2.default);

exports.default = { component: component, config: _config2.default };